import { i18n } from "@/boot/i18n";
import CategoryService from "@/services/category";
import ErrorHandler from "@/tools/errorHandler";
import { REQUIRED } from "../validator/methods";
import * as types from "./mutationTypes";

export default {
  initListState({ commit }) {
    commit(types.SET_CATEGORIES_TREE, []);
  },
  clearListState({ commit }) {
    commit(types.CLEAR_CATEGORIES_TREE);
    commit(types.CLEAR_CATEGORY);
  },
  initNewState({ dispatch }) {
    const validator = validators();
    dispatch("validator/addValidator", validator.nameValidator, { root: true });
    dispatch("validator/addValidator", validator.colorValidator, { root: true });
  },
  clearNewState({ dispatch, commit }) {
    commit(types.CLEAR_CATEGORY);
    dispatch("validator/clearValidator", null, { root: true });
  },
  setCategoriesTreeSuccess({ commit }, categories) {
    commit(types.SET_CATEGORIES_TREE, categories);
  },
  setCategoriesSuccess({ commit }, categories) {
    commit(types.SET_CATEGORIES, categories);
  },
  setCategorySuccess({ commit }, category) {
    commit(types.SET_CATEGORY, category);
  },
  clearCategoriesTree({ commit }) {
    commit(types.CLEAR_CATEGORIES_TREE);
  },
  clearCategories({ commit }) {
    commit(types.CLEAR_CATEGORIES);
  },
  async getAllTree({ rootState, dispatch }, params) {
    try {
      const response = await CategoryService.getAllTree(rootState.organization.organization.uuid, params);
      if (response.data.data) {
        dispatch("setCategoriesTreeSuccess", response.data.data);
      }
    } catch (error) {
      if (error.response.status !== 403) {
        dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
      }
    }
  },
  async getAll({ rootState, dispatch }, params) {
    try {
      const response = await CategoryService.getAll(rootState.organization.organization.uuid, params);
      if (response.data.data) {
        dispatch("setCategoriesSuccess", response.data.data);
      }
    } catch (error) {
      if (error.response.status !== 403) {
        dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
      }
    }
  },
  async update({ dispatch, rootState, state }) {
    try {
      const category = { ...state.category };
      category.name = category.name.trim();
      const response = await CategoryService.update(rootState.organization.organization.uuid, category);
      if (response.data.data) {
        dispatch("setCategorySuccess", response.data.data);
      }
      dispatch("ui/showToastSuccess", i18n.t("category.messages.update_success"), { root: true });
      return true;
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
      return false;
    }
  },
  async create({ dispatch, rootState, state }) {
    try {
      const category = { ...state.category };
      category.name = category.name.trim();
      const response = await CategoryService.create(rootState.organization.organization.uuid, category);
      if (response.data.data) {
        dispatch("setCategorySuccess", response.data.data);
      }
      dispatch("ui/showToastSuccess", i18n.t("category.messages.create_success"), { root: true });
      return true;
    } catch (error) {
      if (error.response.status === 403) {
        dispatch("ui/setModalPermission", true, { root: true });
      } else {
        dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
      }
      return false;
    }
  },
  async delete({ rootState, dispatch }, catUUID) {
    try {
      await CategoryService.delete(rootState.organization.organization.uuid, catUUID);
      return true;
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
      return false;
    }
  },
  async getOne({ rootState, dispatch }, categoryUUID) {
    try {
      const response = await CategoryService.getOne(rootState.organization.organization.uuid, categoryUUID);
      return response.data.data;
    } catch (error) {
      dispatch("ui/showToastError", ErrorHandler.getErrorMessage(error), { root: true });
      return false;
    }
  },
  async save({ dispatch, state }) {
    const valid = await dispatch("validate");
    if (!valid) {
      return false;
    }
    if (state.category.uuid) {
      return dispatch("update");
    } else {
      return dispatch("create");
    }
  },
  setCategory({ commit }, category) {
    commit(types.SET_CATEGORY, category);
  },
  setParent({ commit }, parentUUID) {
    commit(types.SET_PARENT, parentUUID);
  },
  setName({ commit, dispatch }, name) {
    commit(types.SET_NAME, name);
    dispatch("validator/checkValidation", { field: "name", value: name }, { root: true });
  },
  setColor({ commit, dispatch }, color) {
    commit(types.SET_COLOR, color);
    dispatch("validator/checkValidation", { field: "color", value: color }, { root: true });
  },
  validate({ dispatch, state, rootState }) {
    dispatch("validator/validate", { field: "name", value: state.category.name }, { root: true });
    dispatch("validator/validate", { field: "color", value: state.category.color }, { root: true });
    return rootState.validator.errors?.length === 0;
  }
};

const validators = () => {
  return {
    nameValidator: {
      field: "name",
      validations: [{ method: REQUIRED, message: i18n.t("general.rules.required") }]
    },
    colorValidator: {
      field: "color",
      validations: [{ method: REQUIRED, message: i18n.t("general.rules.required") }]
    }
  };
};
